import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

const exceededBackground = "#FCE1EC";
const withinBackground = "#ECFDF5";
const withinText = "#047857";

export const useRiskAppetiteStatusPillStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        statusPill: {
            display: "inline-flex",
            alignItems: "center",
            gap: theme.spacing(1),
            paddingX: theme.spacing(2),
            paddingY: theme.spacing(0.75),
            borderRadius: "20px",
            fontSize: theme.typography.pxToRem(14),
        },
        // The theme sets a default blue fill on every MuiSvgIcon, so the status colour must be applied to the
        // icon fill explicitly (inheriting the pill's text colour is not enough).
        statusPillExceeded: {
            backgroundColor: exceededBackground,
            color: theme.palette.error.main,
            "& svg": {
                fontSize: theme.typography.pxToRem(18),
                fill: theme.palette.error.main,
            },
        },
        statusPillWithin: {
            backgroundColor: withinBackground,
            color: withinText,
        },
    });
};
